import React, { useState, useRef, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import html2canvas from 'html2canvas';

/* ============================================================
   FAKE CHAT GENERATOR - WhatsApp | Instagram | Snapchat
   Monetag Ads Integrated: Push, Popunder, Vignette

   Route: /fake-chat-generator
   ============================================================ */

const FakeChat = () => {
  const [platform, setPlatform] = useState('whatsapp');
  const [contactName, setContactName] = useState('Rahul Sharma');
  const [statusText, setStatusText] = useState('online');
  const [profilePic, setProfilePic] = useState('');
  const [chatDate, setChatDate] = useState('Today');
  const [messageText, setMessageText] = useState('');
  const [messageSender, setMessageSender] = useState('received');
  const [messageTime, setMessageTime] = useState(() => {
    const now = new Date();
    return now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  });
  const [messages, setMessages] = useState([
    { text: 'Hey bro! Did you check the new update? 🔥', sender: 'received', time: '10:30 AM' },
    { text: 'Yeah dude! It\'s insane 💯', sender: 'sent', time: '10:32 AM' },
    { text: 'Let\'s collab on something big! 🚀', sender: 'received', time: '10:33 AM' },
  ]);
  const [showExport, setShowExport] = useState(false);
  const [exportedImg, setExportedImg] = useState('');
  const chatRef = useRef(null);

  /* ═══════════════════════════════════════════════════════════
     🎯 MONETAG AD INTEGRATION - ALL 3 TAGS ACTIVE
     ═══════════════════════════════════════════════════════════ */

  useEffect(() => {
    // 🎯 AD SLOT 1: PUSH NOTIFICATIONS (Dreamy tag - Zone 11164560)
    const pushScript = document.createElement('script');
    pushScript.src = 'https://5gvci.com/act/files/tag.min.js?z=11164560';
    pushScript.setAttribute('data-cfasync', 'false');
    pushScript.async = true;
    document.body.appendChild(pushScript);

    // 🎯 AD SLOT 2: IN-PAGE PUSH (Wise tag - Zone 11302670)
    // Note: In-Page Push uses a different script - add your In-Page tag here if you have one
    // For now, Push + Popunder + Vignette are the main earners

    return () => {
      // Cleanup optional - Monetag handles their own cleanup
    };
  }, []);

  // 🎯 AD SLOT 3: ONCLICK/POPUNDER (Zone 259921)
  // Triggered when user clicks "Download" - HIGHEST PAYING!
  const triggerPopunder = () => {
    const popunderScript = document.createElement('script');
    popunderScript.src = 'https://quge5.com/88/tag.min.js';
    popunderScript.setAttribute('data-zone', '259921');
    popunderScript.setAttribute('data-cfasync', 'false');
    popunderScript.async = true;
    document.body.appendChild(popunderScript);
  };

  // 🎯 AD SLOT 4: VIGNETTE BANNER (Zone 11652159)
  // Full-screen mobile ad after export
  const triggerVignette = () => {
    const vignetteScript = document.createElement('script');
    vignetteScript.dataset.zone = '11652159';
    vignetteScript.src = 'https://n6wxm.com/vignette.min.js';
    document.body.appendChild(vignetteScript);
  };

  /* ═══════════════════════════════════════════════════════════ */

  const wpTheme = {
    headerBg: '#075e54',
    sentBg: '#dcf8c6',
    receivedBg: '#ffffff',
    chatBg: '#e5ddd5',
    statusColor: 'rgba(255,255,255,0.85)',
    tickColor: '#53bdeb',
    textColor: '#111',
    timeColor: '#999',
    dateBg: 'rgba(225,245,254,0.92)',
    dateColor: '#54656f',
    inputBg: '#f0f0f0',
    font: "'Segoe UI', sans-serif",
  };

  const igTheme = {
    headerBg: '#ffffff',
    sentBg: 'linear-gradient(135deg, #833ab4, #fd1d1d, #fcb045)',
    receivedBg: '#efefef',
    chatBg: '#ffffff',
    statusColor: '#8e8e8e',
    tickColor: '#fff',
    textColor: '#fff',
    receivedTextColor: '#262626',
    timeColor: 'rgba(255,255,255,0.8)',
    receivedTimeColor: '#8e8e8e',
    dateBg: '#efefef',
    dateColor: '#8e8e8e',
    inputBg: '#fafafa',
    font: "'Segoe UI', -apple-system, BlinkMacSystemFont, sans-serif",
  };

  const scTheme = {
    headerBg: '#00b2ff',
    sentBg: '#fffc00',
    receivedBg: '#e5e5e5',
    chatBg: '#ffffff',
    statusColor: 'rgba(255,255,255,0.9)',
    tickColor: '#00b2ff',
    textColor: '#000',
    receivedTextColor: '#000',
    timeColor: '#666',
    dateBg: '#f0f0f0',
    dateColor: '#666',
    inputBg: '#f5f5f5',
    font: "'Avenir Next', 'Helvetica Neue', sans-serif",
  };

  const theme = platform === 'instagram' ? igTheme : platform === 'snapchat' ? scTheme : wpTheme;

  const addMessage = () => {
    if (!messageText.trim()) return;
    setMessages([...messages, { text: messageText.trim(), sender: messageSender, time: messageTime }]);
    setMessageText('');
  };

  const deleteMessage = (index) => {
    const newMessages = [...messages];
    newMessages.splice(index, 1);
    setMessages(newMessages);
  };

  const clearAll = () => {
    if (window.confirm('Clear all messages?')) setMessages([]);
  };

  const exportChat = async () => {
    if (!chatRef.current) return;
    try {
      const canvas = await html2canvas(chatRef.current, {
        scale: 2,
        backgroundColor: null,
        useCORS: true,
        logging: false,
      });
      const imgData = canvas.toDataURL('image/png');
      setExportedImg(imgData);
      setShowExport(true);
      triggerVignette(); // 🎯 Show Vignette ad on export
    } catch (err) {
      console.error(err);
      alert('Export failed. Make sure html2canvas is installed!');
    }
  };

  const downloadImage = () => {
    triggerPopunder(); // 🎯 Show Popunder ad on download click
    const link = document.createElement('a');
    link.href = exportedImg;
    link.download = `fake-${platform}-chat.png`;
    link.click();
  };

  useEffect(() => {
    const chatArea = document.getElementById('chat-scroll-area');
    if (chatArea) chatArea.scrollTop = chatArea.scrollHeight;
  }, [messages]);

  const renderWhatsApp = () => (
    <div style={styles.phoneFrame}>
      <div style={{ ...styles.wpHeader, background: wpTheme.headerBg }}>
        <span style={styles.headerIcon}>←</span>
        <div style={styles.profilePic}>
          {profilePic ? (
            <img src={profilePic} alt="" style={styles.profileImg} onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.textContent = '👤'; }} />
          ) : '👤'}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={styles.headerName}>{contactName || 'Contact'}</div>
          <div style={{ ...styles.headerStatus, color: wpTheme.statusColor }}>{statusText}</div>
        </div>
        <div style={styles.headerIcons}>
          <span>📹</span><span>📞</span><span>⋮</span>
        </div>
      </div>
      <div id="chat-scroll-area" style={{ ...styles.chatArea, background: wpTheme.chatBg, backgroundImage: 'url("data:image/svg+xml,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'100\' height=\'100\'><rect fill=\'%23e5ddd5\' width=\'100\' height=\'100\'/><circle fill=\'%23d5cdc5\' cx=\'50\' cy=\'50\' r=\'1.5\'/></svg>")' }}>
        <div style={{ ...styles.dateBubble, background: wpTheme.dateBg, color: wpTheme.dateColor }}>{chatDate}</div>
        {messages.map((msg, i) => (
          <div key={i} style={{
            ...styles.messageBubble,
            alignSelf: msg.sender === 'sent' ? 'flex-end' : 'flex-start',
            background: msg.sender === 'sent' ? wpTheme.sentBg : wpTheme.receivedBg,
            borderBottomRightRadius: msg.sender === 'sent' ? '2px' : '8px',
            borderBottomLeftRadius: msg.sender === 'received' ? '2px' : '8px',
            boxShadow: msg.sender === 'received' ? '0 1px 2px rgba(0,0,0,0.08)' : 'none',
          }}>
            <span style={{ color: wpTheme.textColor, fontSize: '0.88rem', lineHeight: 1.35 }}>{msg.text}</span>
            <span style={{ ...styles.msgTime, color: wpTheme.timeColor }}>
              {msg.time}
              {msg.sender === 'sent' && <span style={{ color: wpTheme.tickColor, marginLeft: 3, fontSize: '0.7rem' }}>✓✓</span>}
            </span>
          </div>
        ))}
      </div>
      <div style={{ ...styles.wpFooter, background: wpTheme.inputBg }}>
        <span style={{ fontSize: '1.3rem' }}>😊</span>
        <span style={{ fontSize: '1.3rem' }}>📎</span>
        <div style={styles.wpInputBox}>Type a message</div>
        <div style={styles.wpMic}>🎤</div>
      </div>
    </div>
  );

  const renderInstagram = () => (
    <div style={styles.phoneFrame}>
      <div style={{ ...styles.igHeader, background: igTheme.headerBg }}>
        <span style={{ fontSize: '1.2rem', color: '#262626' }}>←</span>
        <div style={styles.profilePic}>
          {profilePic ? (
            <img src={profilePic} alt="" style={{ ...styles.profileImg, border: '2px solid #fd1d1d' }} onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.textContent = '👤'; }} />
          ) : '👤'}
        </div>
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ ...styles.headerName, color: '#262626' }}>{contactName || 'Contact'}</div>
          <div style={{ fontSize: '0.7rem', color: igTheme.statusColor }}>{statusText}</div>
        </div>
        <div style={{ display: 'flex', gap: 16, fontSize: '1.1rem', color: '#262626' }}>
          <span>📞</span><span>📹</span><span>ℹ️</span>
        </div>
      </div>
      <div id="chat-scroll-area" style={{ ...styles.chatArea, background: igTheme.chatBg }}>
        <div style={{ ...styles.dateBubble, background: igTheme.dateBg, color: igTheme.dateColor }}>{chatDate}</div>
        {messages.map((msg, i) => (
          <div key={i} style={{
            display: 'flex',
            alignSelf: msg.sender === 'received' ? 'flex-start' : 'flex-end',
            alignItems: 'flex-end',
            gap: 6,
            maxWidth: '80%',
          }}>
            {msg.sender === 'received' && (
              <div style={{ ...styles.igAvatar, flexShrink: 0 }}>
                {profilePic ? (
                  <img src={profilePic} alt="" style={{ width: '100%', height: '100%', borderRadius: '50%', objectFit: 'cover' }} onError={(e) => e.target.style.display = 'none'} />
                ) : '👤'}
              </div>
            )}
            <div style={{
              ...styles.igBubble,
              background: msg.sender === 'sent' ? igTheme.sentBg : igTheme.receivedBg,
              color: msg.sender === 'sent' ? igTheme.textColor : igTheme.receivedTextColor,
              borderBottomLeftRadius: msg.sender === 'received' ? '4px' : '18px',
              borderBottomRightRadius: msg.sender === 'sent' ? '4px' : '18px',
            }}>
              <span style={{ fontSize: '0.88rem', lineHeight: 1.35 }}>{msg.text}</span>
              <span style={{ ...styles.msgTime, color: msg.sender === 'sent' ? igTheme.timeColor : igTheme.receivedTimeColor, marginTop: 4, display: 'block', textAlign: 'right' }}>
                {msg.time}
              </span>
            </div>
          </div>
        ))}
      </div>
      <div style={{ ...styles.igFooter, background: igTheme.inputBg }}>
        <span style={{ fontSize: '1.3rem' }}>📷</span>
        <div style={styles.igInputBox}>Message...</div>
        <span style={{ fontSize: '1.3rem' }}>🎤</span>
        <span style={{ fontSize: '1.3rem' }}>😊</span>
        <span style={{ fontSize: '1.3rem' }}>❤️</span>
      </div>
    </div>
  );

  const renderSnapchat = () => (
    <div style={styles.phoneFrame}>
      <div style={{ ...styles.scHeader, background: scTheme.headerBg }}>
        <span style={{ fontSize: '1.2rem' }}>←</span>
        <div style={{ textAlign: 'center', flex: 1 }}>
          <div style={{ ...styles.headerName, fontSize: '1rem' }}>{contactName || 'Contact'}</div>
          <div style={{ fontSize: '0.7rem', color: scTheme.statusColor }}>{statusText}</div>
        </div>
        <div style={{ display: 'flex', gap: 14, fontSize: '1.1rem' }}>
          <span>📹</span><span>📞</span>
        </div>
      </div>
      <div id="chat-scroll-area" style={{ ...styles.chatArea, background: scTheme.chatBg }}>
        <div style={{ ...styles.dateBubble, background: scTheme.dateBg, color: scTheme.dateColor }}>{chatDate}</div>
        {messages.map((msg, i) => (
          <div key={i} style={{
            ...styles.scBubble,
            alignSelf: msg.sender === 'sent' ? 'flex-end' : 'flex-start',
            background: msg.sender === 'sent' ? scTheme.sentBg : scTheme.receivedBg,
            color: msg.sender === 'sent' ? scTheme.textColor : scTheme.receivedTextColor,
            borderBottomRightRadius: msg.sender === 'sent' ? '4px' : '16px',
            borderBottomLeftRadius: msg.sender === 'received' ? '4px' : '16px',
          }}>
            <span style={{ fontSize: '0.88rem', lineHeight: 1.35 }}>{msg.text}</span>
            <span style={{ ...styles.msgTime, color: scTheme.timeColor }}>
              {msg.time}
              {msg.sender === 'sent' && <span style={{ marginLeft: 4, fontSize: '0.65rem' }}>✓</span>}
            </span>
          </div>
        ))}
      </div>
      <div style={{ ...styles.scFooter, background: scTheme.inputBg }}>
        <span style={{ fontSize: '1.3rem' }}>📎</span>
        <div style={styles.scInputBox}>Send a chat</div>
        <span style={{ fontSize: '1.3rem' }}>😊</span>
      </div>
    </div>
  );

  return (
    <div style={styles.page}>
      <Helmet>
        <title>Fake Chat Generator | WhatsApp, Instagram & Snapchat - Free</title>
        <meta name="description" content="Create realistic fake WhatsApp, Instagram DM and Snapchat conversations for free. Generate chat screenshots for memes, pranks & content." />
        <meta name="keywords" content="fake whatsapp chat, fake instagram dm, fake snapchat chat, chat generator, prank chat, meme generator, fake conversation" />
        <meta property="og:title" content="Fake Chat Generator - Free WhatsApp, Instagram & Snapchat" />
        <meta property="og:description" content="Create realistic fake chats for memes and pranks. Free & easy to use!" />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://alphaapkstore.com/fake-chat-generator" />
        <link rel="canonical" href="https://alphaapkstore.com/fake-chat-generator" />
      </Helmet>

      <div style={styles.container}>
        <div style={styles.titleSection}>
          <h1 style={styles.title}>💬 Fake Chat Generator</h1>
          <p style={styles.subtitle}>Create realistic WhatsApp, Instagram & Snapchat conversations</p>
        </div>

        <div style={styles.mainGrid}>
          <div style={styles.previewSection}>
            <div style={styles.platformTabs}>
              {[
                { id: 'whatsapp', label: 'WhatsApp', icon: '💚', color: '#25d366' },
                { id: 'instagram', label: 'Instagram', icon: '💜', color: '#e1306c' },
                { id: 'snapchat', label: 'Snapchat', icon: '💛', color: '#fffc00' },
              ].map((p) => (
                <button
                  key={p.id}
                  onClick={() => setPlatform(p.id)}
                  style={{
                    ...styles.tabBtn,
                    background: platform === p.id ? p.color : '#f0f0f0',
                    color: platform === p.id ? (p.id === 'snapchat' ? '#000' : '#fff') : '#555',
                    transform: platform === p.id ? 'scale(1.05)' : 'scale(1)',
                  }}
                >
                  {p.icon} {p.label}
                </button>
              ))}
            </div>

            <div ref={chatRef}>
              {platform === 'whatsapp' && renderWhatsApp()}
              {platform === 'instagram' && renderInstagram()}
              {platform === 'snapchat' && renderSnapchat()}
            </div>
            <button onClick={exportChat} style={styles.exportBtn}>
              📸 Download as Image
            </button>
          </div>

          <div style={styles.controls}>
            <h2 style={styles.sectionTitle}>⚙️ Chat Settings</h2>

            <div style={styles.controlGroup}>
              <label style={styles.label}>Contact Name</label>
              <input style={styles.input} value={contactName} onChange={(e) => setContactName(e.target.value)} />
            </div>

            <div style={styles.controlGroup}>
              <label style={styles.label}>Status Text</label>
              <input style={styles.input} value={statusText} onChange={(e) => setStatusText(e.target.value)} />
            </div>

            <div style={styles.controlGroup}>
              <label style={styles.label}>Profile Pic URL</label>
              <input style={styles.input} placeholder="Paste image URL" value={profilePic} onChange={(e) => setProfilePic(e.target.value)} />
            </div>

            <div style={styles.controlGroup}>
              <label style={styles.label}>Chat Date</label>
              <input style={styles.input} value={chatDate} onChange={(e) => setChatDate(e.target.value)} />
            </div>

            <h2 style={{ ...styles.sectionTitle, marginTop: 20 }}>💬 Add Message</h2>

            <div style={styles.controlGroup}>
              <label style={styles.label}>Message</label>
              <textarea
                style={{ ...styles.input, minHeight: 60, resize: 'vertical' }}
                placeholder="Type your message..."
                value={messageText}
                onChange={(e) => setMessageText(e.target.value)}
                onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); addMessage(); } }}
              />
            </div>

            <div style={styles.controlGroup}>
              <label style={styles.label}>Sender</label>
              <select style={styles.input} value={messageSender} onChange={(e) => setMessageSender(e.target.value)}>
                <option value="received">Received (Other Person)</option>
                <option value="sent">Sent (You)</option>
              </select>
            </div>

            <div style={styles.controlGroup}>
              <label style={styles.label}>Time</label>
              <input style={styles.input} value={messageTime} onChange={(e) => setMessageTime(e.target.value)} />
            </div>

            <button onClick={addMessage} style={{ ...styles.btn, background: '#25d366', color: '#fff' }}>
              ➕ Add Message
            </button>

            <h2 style={{ ...styles.sectionTitle, marginTop: 20 }}>📋 Messages ({messages.length})</h2>
            <div style={styles.messageList}>
              {messages.length === 0 ? (
                <div style={{ textAlign: 'center', color: '#999', padding: 10 }}>No messages yet</div>
              ) : (
                messages.map((msg, i) => (
                  <div key={i} style={styles.messageItem}>
                    <span style={styles.messageItemText}>{msg.text.length > 30 ? msg.text.substring(0, 30) + '...' : msg.text}</span>
                    <span style={{ ...styles.messageItemTag, background: msg.sender === 'sent' ? '#dcf8c6' : '#e3f2fd', color: msg.sender === 'sent' ? '#2e7d32' : '#1565c0' }}>
                      {msg.sender}
                    </span>
                    <button onClick={() => deleteMessage(i)} style={styles.deleteBtn}>🗑️</button>
                  </div>
                ))
              )}
            </div>

            <button onClick={clearAll} style={{ ...styles.btn, background: '#ff4444', color: '#fff' }}>
              🗑️ Clear All
            </button>
          </div>
        </div>
      </div>

      {showExport && (
        <div style={styles.modalOverlay} onClick={() => setShowExport(false)}>
          <div style={styles.modalBox} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ marginBottom: 12 }}>🎉 Your Chat is Ready!</h3>
            <img src={exportedImg} alt="Exported" style={{ maxWidth: '100%', borderRadius: 12, marginBottom: 12, boxShadow: '0 4px 16px rgba(0,0,0,0.1)' }} />
            <div style={{ display: 'flex', gap: 10 }}>
              <button onClick={downloadImage} style={{ ...styles.btn, flex: 1, background: '#25d366', color: '#fff' }}>⬇️ Download</button>
              <button onClick={() => setShowExport(false)} style={{ ...styles.btn, flex: 1, background: '#f0f0f0', color: '#333' }}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f0f2f5',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    paddingBottom: 40,
  },
  container: {
    maxWidth: 1200,
    margin: '0 auto',
    padding: '20px',
  },
  titleSection: {
    textAlign: 'center',
    padding: '30px 0 20px',
  },
  title: {
    color: '#075e54',
    fontSize: '2.2rem',
    marginBottom: 8,
  },
  subtitle: {
    color: '#666',
    fontSize: '1rem',
  },
  mainGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 380px',
    gap: 25,
  },
  previewSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 20,
  },
  platformTabs: {
    display: 'flex',
    justifyContent: 'center',
    gap: 12,
    marginBottom: 10,
    flexWrap: 'wrap',
  },
  tabBtn: {
    padding: '12px 24px',
    border: 'none',
    borderRadius: 50,
    fontSize: '0.95rem',
    fontWeight: 700,
    cursor: 'pointer',
    transition: 'all 0.2s',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
  },
  phoneFrame: {
    background: '#e5ddd5',
    width: '100%',
    maxWidth: 360,
    borderRadius: 20,
    overflow: 'hidden',
    boxShadow: '0 8px 32px rgba(0,0,0,0.15)',
    fontFamily: "'Segoe UI', sans-serif",
  },
  wpHeader: {
    color: 'white',
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  igHeader: {
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    borderBottom: '1px solid #dbdbdb',
  },
  scHeader: {
    color: 'white',
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
  },
  headerIcon: {
    fontSize: '1.2rem',
    cursor: 'pointer',
  },
  profilePic: {
    width: 38,
    height: 38,
    borderRadius: '50%',
    background: '#ddd',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.2rem',
    overflow: 'hidden',
    flexShrink: 0,
  },
  profileImg: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  headerName: {
    fontSize: '0.95rem',
    fontWeight: 600,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  headerStatus: {
    fontSize: '0.7rem',
    marginTop: 1,
  },
  headerIcons: {
    display: 'flex',
    gap: 18,
    fontSize: '1.1rem',
  },
  chatArea: {
    minHeight: 450,
    maxHeight: 550,
    overflowY: 'auto',
    padding: 12,
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  dateBubble: {
    alignSelf: 'center',
    fontSize: '0.72rem',
    padding: '5px 12px',
    borderRadius: 8,
    margin: '6px 0',
    boxShadow: '0 1px 2px rgba(0,0,0,0.08)',
  },
  messageBubble: {
    maxWidth: '78%',
    padding: '7px 10px',
    borderRadius: 8,
    position: 'relative',
    wordWrap: 'break-word',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  msgTime: {
    fontSize: '0.65rem',
    alignSelf: 'flex-end',
    marginTop: 2,
  },
  wpFooter: {
    padding: '8px 10px',
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  wpInputBox: {
    flex: 1,
    background: 'white',
    borderRadius: 20,
    padding: '8px 14px',
    fontSize: '0.9rem',
    color: '#999',
  },
  wpMic: {
    width: 36,
    height: 36,
    background: '#075e54',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    fontSize: '1.1rem',
  },
  igBubble: {
    padding: '10px 14px',
    borderRadius: 18,
    maxWidth: '100%',
    wordWrap: 'break-word',
  },
  igAvatar: {
    width: 28,
    height: 28,
    borderRadius: '50%',
    background: '#ddd',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.8rem',
    overflow: 'hidden',
  },
  igFooter: {
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    borderTop: '1px solid #dbdbdb',
  },
  igInputBox: {
    flex: 1,
    background: '#efefef',
    borderRadius: 20,
    padding: '8px 14px',
    fontSize: '0.9rem',
    color: '#8e8e8e',
  },
  scBubble: {
    maxWidth: '75%',
    padding: '10px 14px',
    borderRadius: 16,
    wordWrap: 'break-word',
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
  },
  scFooter: {
    padding: '10px 14px',
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    borderTop: '1px solid #e0e0e0',
  },
  scInputBox: {
    flex: 1,
    background: '#e5e5e5',
    borderRadius: 20,
    padding: '8px 14px',
    fontSize: '0.9rem',
    color: '#999',
  },
  exportBtn: {
    padding: '14px 28px',
    background: '#075e54',
    color: 'white',
    border: 'none',
    borderRadius: 12,
    fontSize: '1rem',
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(7,94,84,0.3)',
    transition: 'transform 0.2s',
  },
  controls: {
    background: 'white',
    borderRadius: 16,
    padding: 24,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    height: 'fit-content',
  },
  sectionTitle: {
    fontSize: '1.1rem',
    color: '#333',
    marginBottom: 16,
    paddingBottom: 10,
    borderBottom: '2px solid #25d366',
  },
  controlGroup: {
    marginBottom: 14,
  },
  label: {
    display: 'block',
    fontSize: '0.85rem',
    color: '#555',
    marginBottom: 6,
    fontWeight: 600,
  },
  input: {
    width: '100%',
    padding: '10px 14px',
    border: '1.5px solid #e0e0e0',
    borderRadius: 10,
    fontSize: '0.9rem',
    transition: 'border-color 0.2s',
    fontFamily: "inherit",
    outline: 'none',
  },
  btn: {
    width: '100%',
    padding: 12,
    border: 'none',
    borderRadius: 10,
    fontSize: '0.95rem',
    fontWeight: 600,
    cursor: 'pointer',
    marginBottom: 10,
  },
  messageList: {
    maxHeight: 180,
    overflowY: 'auto',
    border: '1px solid #e0e0e0',
    borderRadius: 10,
    padding: 8,
    marginBottom: 12,
  },
  messageItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 10px',
    background: '#f8f9fa',
    borderRadius: 8,
    marginBottom: 6,
    fontSize: '0.82rem',
  },
  messageItemText: {
    flex: 1,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginRight: 8,
  },
  messageItemTag: {
    fontSize: '0.7rem',
    padding: '2px 8px',
    borderRadius: 12,
    fontWeight: 600,
    flexShrink: 0,
  },
  deleteBtn: {
    background: 'none',
    border: 'none',
    color: '#ff4444',
    cursor: 'pointer',
    fontSize: '1rem',
    marginLeft: 6,
  },
  modalOverlay: {
    position: 'fixed',
    top: 0, left: 0, right: 0, bottom: 0,
    background: 'rgba(0,0,0,0.7)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000,
    padding: 20,
  },
  modalBox: {
    background: 'white',
    borderRadius: 16,
    padding: 24,
    maxWidth: 420,
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
};

export default FakeChat;